import React from 'react';
import Footer from '../components/Footer';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEOHead from '../seo/SEOHead';
import { PAGE_SEO } from '../seo/seoConfig';

const UsefulLinks = () => {
  const navigate = useNavigate();
  const [showShopNow, setShowShopNow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowShopNow(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleShopNow = () => {
    navigate('/product/png-stove');
  };

  return (
    <>
      <SEOHead
        title={PAGE_SEO.usefulLinks.title}
        description={PAGE_SEO.usefulLinks.description}
        keywords={PAGE_SEO.usefulLinks.keywords}
        canonical={PAGE_SEO.usefulLinks.canonical}
        ogImage={PAGE_SEO.usefulLinks.ogImage}
      />
      <div className="useful-links-container">
      <div className="useful-links-content">
        <div className="video-cubicle">
  <iframe
    className="video-cubicle-iframe"
    src="https://www.youtube.com/embed/k_G5DnJvSz4"
    title="YouTube video player"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerPolicy="strict-origin-when-cross-origin"
    allowFullScreen
  ></iframe>
</div>
{showShopNow && (
          <div className="product-actions">
            <button className="product-action-btn primary" onClick={handleShopNow}>
              Shop Now
            </button>
          </div>
        )}
      </div>

      <style>{`
        .useful-links-container {
          width: 100%;
          max-width: var(--max-width);
          margin: 0 auto;
          padding: 0 var(--left-right-padding);
        }

        .useful-links-content {
          margin: var(--spacing-5) 0;
        }

        .useful-links-heading {
          font-family: var(--font-family-primary);
          font-size: var(--font-size-4);
          font-weight: var(--font-weight-2);
          margin-bottom: var(--spacing-3);
          color: var(--color-1);
        }

        .video-cubicle {
          position: relative;
          width: 100%;
          max-width: 260px;
          aspect-ratio: 9 / 16;
          max-height: 50vh;
          margin: 0 auto;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .video-cubicle-iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: none;
        }
.product-actions {
  text-align: center;
  margin-top: var(--spacing-4);
  max-width: 360px;      /* video jitni width, ya jo bhi chahiye */
  margin-left: auto;
  margin-right: auto;
}

        .product-actions p {
          font-family: var(--font-family-tertiary);
          font-size: var(--font-size-2);
          margin-bottom: var(--spacing-2);
        }

        .product-action-btn.primary {
          background-color: var(--color-1);
          color: var(--color-white);
          border: none;
          padding: 12px 32px;
          border-radius: 6px;
          font-family: var(--font-family-primary);
          font-size: var(--font-size-2);
          font-weight: var(--font-weight-2);
          cursor: pointer;
          transition: background-color 0.3s ease, transform 0.2s ease;
        }

        .product-action-btn.primary:hover {
          background-color: #d96f10;
          transform: translateY(-2px);
        }

        @media (max-width: 768px) {
          .product-actions {
            padding: 0 var(--spacing-2);
          }

          .product-action-btn.primary {
            width: 100%;
            padding: 14px 0;
            font-size: var(--font-size-1);
          }
        }
        
        @media (max-width: 768px) {
          .video-cubicle {
            max-width: 100%;
            max-height: 45vh;
            border-radius: 4px;
          }
        }
      `}</style>
    </div>
    <Footer/>
    </>
  );
};

export default UsefulLinks;